import React, { useEffect } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import EcoGraphicSwiper from 'eco-design/sections/eco-graphic-swiper';
import EFPicture from 'elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.ListA1');
    const itemsA = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744280518640/list1_1.jpg',
            title: t('item1_title'),
            desc: t('item1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744280518272/list1_2.jpg',
            title: t('item2_title'),
            desc: t('item2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744280518454/list1_3.jpg',
            title: t('item3_title'),
            desc: t('item3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1744101625498/list1_4.jpg',
            title: t('item4_title'),
            desc: t('item4_desc'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const wrapper = document.querySelector('.list-swiper-box .wrapper') as HTMLDivElement;
            const swiper = document.querySelector('.list-swiper-box .swiper-box') as HTMLDivElement;
            AniContainer.create({
                syncFromTo: [['.list-swiper-box .swiper-box', { x: 0 }, { x: wrapper?.offsetWidth - swiper?.offsetWidth }]],
                triggerElement: '.list-swiper-box',
                triggerHook: 1,
                offset: '100%',
                duration: '200%',
            });
        }
    }, []);

    return (
        <div className={styles.comp}>
            {/* <EcoSpace /> */}

            {/* <EcoGraphicSwiper items={itemsA} /> */}
            <div className="list-swiper-box">
                <div className="sticky">
                    <div className="inner-box">
                        <EcoSectionCommon title={t('title')} />
                        <EcoSpaceSmall />
                        <div className="wrapper">
                            <ul className="swiper-box">
                                {itemsA?.map((item: any, k: number) => (
                                    <li className="swiper-item" key={k}>
                                        <div className="card-img">
                                            <EFPicture src={item?.pc} alt={item?.title} />
                                        </div>
                                        <p className="card-title">{item?.title}</p>
                                        <p className="card-desc">{item?.desc}</p>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
